import React from 'react'

import Text from 'components/typography/Text/Text'
import Box from 'components/layout/Box/Box'
import CircleLoader from 'components/ui/CircleLoader/CircleLoader'
import { Cell, Grid } from 'components/layout/grid'

import statImage from './images/stat.svg'

import s from './WeatherItem.scss'


const WeatherItem = ({ onItemClick, ...data }) => {
  const { title, subTitle, value, units, isFetching, graphId } = data

  return (
    <Box
      className={s.grid}
      pt="8"
      pb="8"
    >
      <Grid columns={2} gutter="md">
        <Cell size={1}>
          <Text
            message={title}
            size="20-24"
          />
          {
            Boolean(subTitle) && (
              <Box pt="4">
                <Text
                  message={subTitle}
                  color="gray"
                  size="12-14"
                  tag="div"
                />
              </Box>
            )
          }
        </Cell>
        <Cell size={1} align="left">
          {
            isFetching ? (
              <CircleLoader />
            ) : (
              <Text
                message={value}
                size="20-24"
              />
            )
          }
          {
            Boolean(graphId) && (
              <Box ml="8">
                <Box
                  className={s.graph}
                  pt="4"
                  pb="4"
                  pl="12"
                  pr="12"
                  onClick={() => onItemClick(data)}
                >
                  <img
                    className={s.statImage}
                    src={statImage}
                  />
                </Box>
              </Box>
            )
          }
        </Cell>
      </Grid>
    </Box>
  )
}


export default WeatherItem
